import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import PropTypes from "prop-types";
import * as classes from "./Image.module.css";

const Image = ({
  image,
  sided = false,
  card = false,
  contact = false,
  accordion = false
}) => {
  return (
    <GatsbyImage
      image={image.gatsbyImageData}
      alt={image.title}
      className={
        accordion
          ? classes.accordion
          : sided
          ? classes.sided
          : card
          ? classes.card
          : contact
          ? classes.contact
          : ""
      }
    />
  );
};

Image.propTypes = {
  image: PropTypes.object.isRequired,
  sided: PropTypes.bool,
  card: PropTypes.bool,
  contact: PropTypes.bool
};

export default Image;
